import Vue from 'vue';

const mutations = {
	register(state, name) {
		if (name in state.overlays) {
			console.warn(`Replaced overlay with id '${name}' because similar overlay id already exists`);
		}
		Vue.set(state.overlays, name, {
			active: false,
		});
	},
	unregister(state, name) {
		if (name in state.overlays) {
			Vue.delete(state.overlays, name);
		} else {
			console.warn(`tried to unregister overlay with id '${name}' while it is not registered`);
		}
	},
	toggle(state, payload) {
		if (payload.name in state.overlays) {
			let newActiveState = !state.overlays[payload.name].active;

			if ('active' in payload && typeof payload.active === 'boolean') {
				newActiveState = payload.active;
			}

			if (newActiveState !== state.overlays[payload.name].active) {
				state.overlays[payload.name].active = newActiveState;

				// Close all other overlays
				for (const key in state.overlays) {
					if (key !== payload.name) {
						state.overlays[key].active = false;
					}
				}
			}
		} else {
			console.warn(`Cannot toggle overlay with id '${payload.name}' because it does not exist`);
		}
	},
	updateLastScrollY(state) {
		state.lastScrollY = window.pageYOffset;
	},
	togglePageWrap(state, active) {
		if (active) {
			state.pageWrapStyle = {
				position: 'fixed',
				top: `${-state.lastScrollY}px`,
				left: 0,
				right: 0,
			};
		} else {
			state.pageWrapStyle = {
				position: '',
				top: '',
				left: '',
				right: '',
			};
		}
	},
};

export default mutations;



// WEBPACK FOOTER //
// ./scripts/sky-overlay/store/mutations.js